export const NOTIFICATION_SEND_REQUESTED = "NOTIFICATION_SEND_REQUESTED";
export const NOTIFICATION_SEND_SUCCEEDED = "NOTIFICATION_SEND_SUCCEEDED";
export const NOTIFICATION_SEND_FAILED = "NOTIFICATION_SEND_FAILED";